import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SimReplacementBlockData from "app/Models/Content/SimReplacementBlockData";
import SimActivation from "app/Components/Block/SimReplacementBlock/SimReplacement";

export default class PrivateSimActivationBlock extends EpiComponent<SimReplacementBlockData> {

    constructor(props) {
        super(props);
    }

    public render(): ReactNode | ReactNodeArray | null {
        return <SimActivation context={this.getContext()} iContent={this.props.data}/>
    }
}


